import React from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";

const Footer = () => {
  return (
    <>
      {/* Footer */}
      <footer className="footer">
        <div className="footer-bg">
          <ImageWithBasePath
            src="assets/img/bg/footer-bg-01.png"
            className="footer-bg-1"
            alt=""
          />
          <ImageWithBasePath
            src="assets/img/bg/footer-bg-02.png"
            className="footer-bg-2"
            alt=""
          />
        </div>

        <div className="footer-top">
          <div className="container">
            <div className="row row-gap-2 my-2">
              <div className="col-lg-6">
                <div className="footer-about">
                  <div className="footer-logo">
                    <ImageWithBasePath
                      src="assets/img/logo.png"
                      alt="ApiTwist Class"
                    />
                  </div>
                  <p>
                    ApiLingua is an AI-powered English learning platform that turns understanding into speaking. With 6,000+ expert-crafted interactive activities, structured CEFR-aligned content, and instant AI feedback, we help learners build real fluency through smart, adaptive practice.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 mt-lg-5">
                <div className="footer-widget footer-menu d-lg-flex flex-column justify-content-end align-items-end">
                  <h5 className="footer-title">Improve Speaking Skills</h5>
                  <div className="d-flex align-items-center">
                    <a
                      href="https://apps.apple.com/us/app/apilingua-learn-english/id6445865305"
                      className="me-2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <ImageWithBasePath
                        src="assets/img/icon/appstore.svg"
                        alt=""
                      />
                    </a>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.learnenaglish.mobile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <ImageWithBasePath
                        src="assets/img/icon/googleplay.svg"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-4">
                <div className="footer-widget footer-contact">
                  <h5 className="footer-title">Bize Ulaşın</h5>
                  <div className="footer-contact-info">
                    <div className="footer-address d-flex align-items-center">
                      <ImageWithBasePath
                        src="assets/img/icon/icon-20.svg"
                        alt="Img"
                        className="img-fluid me-2"
                      />
                      <p>
                        Üniversite Mh. Sarıgül Sk. No:37/1 İç Kapı No:34
                        Entertech İstanbul Teknokent
                        <br /> Avcılar/İstanbul
                      </p>
                    </div>
                    <div className="footer-address d-flex align-items-center">
                      <ImageWithBasePath
                        src="assets/img/icon/icon-19.svg"
                        alt="Img"
                        className="img-fluid me-2"
                      />
                      <a href="mailto:support@apitwist.com">
                        support@apitwist.com
                      </a>
                    </div>
                    <div className="footer-address d-flex align-items-center">
                      <ImageWithBasePath
                        src="assets/img/icon/icon-21.svg"
                        alt="Img"
                        className="img-fluid me-2"
                      />
                      <a href="tel:+905316535825">+90 531 653 58 25</a>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="container">
            <div className="row row-gap-2">
              <div className="col-md-6">
                <div className="text-center text-md-start">
                  <p className="text-white">
                    Copyright © {new Date().getFullYear()} <a
                      href="https://apilingua.co.uk"
                      target="_blank"
                      rel="noopener noreferrer"
                  >
                      <span className="text-secondary">ApiLingua</span>
                  </a> is a{" "}
                    <a
                      href="https://girift.tech"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <span className="text-secondary">Girift EdTech</span>
                    </a>{" "}
                    product. All rights reserved
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div>
                  <ul className="d-flex align-items-center justify-content-center justify-content-md-end footer-link">
                    <li>
                      <a
                        href="https://apitwist.com/policies"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Privacy Policy
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      {/* /Footer */}
    </>
  );
};

export default Footer;
